import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import React, { ReactNode } from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import * as Styled from "./ReportSettings.styles";

interface ReportSettingsProps {
    reports?: ReactNode;
    filters?: ReactNode;
    filtersPadding?: string;
}

export const ReportSettings = ({ filters, filtersPadding, reports }: ReportSettingsProps) => {
    return (
        <Styled.Container>
            <Accordion elevation={0} defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    {Translations.Reports}
                </AccordionSummary>
                <AccordionDetails>
                    {reports}
                </AccordionDetails>
            </Accordion>
            <Accordion elevation={0} defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    {Translations.FilterCondition}
                </AccordionSummary>
                <AccordionDetails style={{ padding: filtersPadding }}>
                    {filters}
                </AccordionDetails>
            </Accordion>
        </Styled.Container>
    );
};
